import { render, staticRenderFns } from "./detailspage.vue?vue&type=template&id=582ff0a5&"
import script from "./detailspage.vue?vue&type=script&lang=js&"
export * from "./detailspage.vue?vue&type=script&lang=js&"
import style0 from "./detailspage.vue?vue&type=style&index=0&id=582ff0a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports